module.exports = __webpack_public_path__ + "img/icon_comment.5f7c60c0.svg";